var NAMESPACE = "ALL_ABOARD_THE_BUS";
var subscribeChannel = function subscribeChannel(handler) {
  var channel = new BroadcastChannel(NAMESPACE);
  channel.addEventListener("message", handler);
  return function () {
    return channel.close();
  };
};
var subscribeWindow = function subscribeWindow(handler) {
  window.addEventListener("message", handler);
  return function () {
    return window.removeEventListener("message", handler);
  };
};
var listenToGlobal = function listenToGlobal(callback, filter) {
  return subscribeChannel(function (event) {
    if (!filter || filter(event.data)) {
      callback(event.data);
    }
  });
};
var listenToLocal = function listenToLocal(callback, filter) {
  return subscribeWindow(function (event) {
    if (event.origin === window.origin && event.data.type === NAMESPACE && (!filter || filter(event.data.message))) {
      callback(event.data.message);
    }
  });
};
export var listen = function listen(callback, filter) {
  var u1 = listenToGlobal(callback, filter);
  var u2 = listenToLocal(callback, filter);
  return function () {
    u1();
    u2();
  };
};
export var sendLocal = function sendLocal(message) {
  return window.postMessage({
    type: NAMESPACE,
    message: message
  }, window.origin);
};
export var sendGlobal = function sendGlobal(message) {
  var channel = new BroadcastChannel(NAMESPACE);
  channel.postMessage(message);
  channel.close();
};